import React, { useEffect } from 'react';
import { UseHookContactUS } from './hook';
import upload from "../../assets/upload.png";
import "../../styles/contactus.css";
import { Link } from 'react-router-dom';
import { ErrorMessage, Field, Form, Formik } from "formik";
import { Enums } from '../../constants/enums';
import CompaintAccordionItem from './CompaintAccordionItem';
import { Toast } from 'primereact/toast';
import { confirmDialog } from 'primereact/confirmdialog';
import { ConfirmDialog } from 'primereact/confirmdialog';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';

export default function VZYContactUs () {
	const {
		formFieldAction,
		isDisabled,
		setIsDisabled,
		selectedCategory,
		category,
		OnChangeCategory,
		subCategory,
		selectedSubCategory,
		selectedSubChildCategory,
		subChildCategory,
		//OnChangeSubChildCategory,
		OnChangeSubCategory,

		stepDIY,
		ConfirmYesButtonOnclick,
		ConfirmNOButtonOnclick,
		SubmitOnclick,
		validationSchema,
		ChannelPartners,
		selectedPartner,
		OnChangeChannelpartner,
		ButtonAction,
		tabHelpActive,
		tabTicketActive,
		watchoTabOnclick,
		WatchoComplaint,
		image,
		onUploadFile,
		toast,
		setSubChildCategory,
		OnChangeSubChildCategory,
		linkUrl,
		selectedOTTPlans,
		oTTPlans,
		selectedCouponfield,
		AvailableCoupon,
		searchCoupon,
		couponCode,
		setCouponCode, visible, setVisible, dialogData, setDialogData,
		DeActiveSteps, typebutton, selectedSorcefield, buttonColor
	} = UseHookContactUS();
	return (
		<div id="containerQRC">
			{/* <Toast ref={toast} /> */}
			 <Toast ref={toast} position="bottom-center" />
			<div className='contactus'>
				<Formik
					initialValues={{
						Subject: "",
						email: "",
						CategoryText: "",
						SubCategoryText: "",
						SubChildCategoryText: "",
						Category: "",
						SubCategory: "",
						SubChildCategory: "",
						description: ""
					}}
					validationSchema={validationSchema}

					onSubmit={(values, { resetForm }) => {
						// Your custom submit logic
						SubmitOnclick(values, resetForm);

						// Reset the form after submission

					}}
				>{({ setFieldValue,resetForm }) => (
					<div id="contactus-page">
						<div className="create-ticket">
							<div className="content-header">
								<div className="header-name">
									<h2>Help/Write to Us</h2>
								</div>
							</div>
							<ul className="nav nav-tabs" id="MyContactus" role="tablist">
								<li className="nav-item" onClick={(e) => watchoTabOnclick("help", e, resetForm)}>
									<Link to="/Help/help-support" className={`nav-link ${tabHelpActive}`}>Help</Link>
								</li>
								<li className="nav-item" onClick={(e) => watchoTabOnclick("tickets", e, resetForm)} >
									<Link to="/Help/help-support" className={`nav-link ${tabTicketActive}`}>View Past Tickets</Link>
								</li>
							</ul>
							<div className="tab-content" id="MyContactusContent">
								<div className={`tab-pane fade show ${tabHelpActive}`} id="contactus" role="tabpanel" aria-labelledby="contactus-tab">
									<div className="ticketForm">


										<Form id="contactForm">
											{formFieldAction && (
												<>
													<div className="form-group row">
														<label className="email" htmlFor="email">Email<span className="astrik">*</span></label>
														<div className="input-errormsg">
															<Field
																name="email"
																type="text"
																className="form-control"
																placeholder="Email"
															/>
															<ErrorMessage
																name="email"
																component="small"
																className="p-error"
															/>
														</div>
													</div>
													<div className="form-group row">
														<label className="subject" htmlFor="subject">Subject<span className="astrik">*</span></label>
														<div className="input-errormsg">
															<Field
																name="Subject"
																type="text"
																className="form-control"
																placeholder="Subject"
															/>
															<ErrorMessage
																name="Subject"
																component="small"
																className="p-error"
															/>
														</div>
													</div>
												</>
											)}
											<div className="form-group row">
												<label className="category" htmlFor="category">Category<span className="astrik">*</span></label>
												<div className="input-errormsg">
													<Field
														as="select"
														name="Category"
														className="form-controls"
														value={selectedCategory}
														onChange={(e) => {
															const value = e.target.value;
															const text = e.target.options[e.target.selectedIndex].text;
															setFieldValue("Category", value);
															setFieldValue("CategoryText", text);
															OnChangeCategory(e,text);
														}}
													>
														<option value="">-- Select the category --</option>
														{category?.responseList.map((item, index) => (
															<option key={index} value={item.parentCategoryId}>
																{item.parentCategoryName}
															</option>
														))}
													</Field>
													<ErrorMessage
														name="Category"
														component="small"
														className="p-error"
													/>
													<span className="category-error"></span>
												</div>
											</div>
											<div className="form-group row">
												<label className="subcategory" htmlFor="subcategory">Sub Category<span className="astrik">*</span></label>
												<div className="input-errormsg">
													<Field disabled={isDisabled}
														as="select"
														name="SubCategory"
														className="form-controls"
														value={selectedSubCategory}
														onChange={(e) => {
															const value = e.target.value;
															const text = e.target.options[e.target.selectedIndex].text;
															setFieldValue("SubCategory", value);
															setFieldValue("SubCategoryText", text);
															OnChangeSubCategory(e,text);
														}}
													>
														<option value="">Select the sub category</option>
														{subCategory?.responseList.map((item, index) => (
															<option key={index} value={item.categoryId}>
																{item.category}
															</option>
														))}
													</Field>
													<ErrorMessage
														name="SubCategory"
														component="small"
														className="p-error"
													/>
												</div>
											</div>
											{subChildCategory && subChildCategory.responseList.length > 0 && (
												<div className="form-group row">
													<label className="subcildcategory" htmlFor="subchildcategory">Sub Sub Category<span className="astrik">*</span></label>
													<div className="input-errormsg">
														<Field
															as="select"
															name="SubChildCategory"
															className="form-controls"
															value={selectedSubChildCategory}
															onChange={(e) => {
																const value = e.target.value;
																const text = e.target.options[e.target.selectedIndex].text;
																setFieldValue("SubChildCategory", value);
																setFieldValue("SubChildCategoryText", text);
																OnChangeSubChildCategory(e,text);
															}}
														>
															<option value="">Select the sub sub category</option>
															{subChildCategory?.responseList.map((item, index) => (
																<option key={index} value={item.categoryId}>
																	{item.category}
																</option>
															))}
														</Field>
														<ErrorMessage
															name="SubChildCategory"
															component="small"
															className="p-error"
														/>
													</div>
												</div>)}
											{selectedCouponfield && (
												<div className="form-group row">
													<label className="couponCode" htmlFor="couponCode">CouponCode<span className="astrik">*</span></label>
													<div className="input-errormsg d-flex align-items-start gap-2">
														<input
															name="couponCode"
															type="text"
															className="form-control"
															placeholder="Enter coupon Code"
															value={couponCode}
															onChange={(e) => setCouponCode(e.target.value)}
														/>
														<button type="button" className="btn btn-secondary" onClick={searchCoupon}>
															Search
														</button>
														<ErrorMessage
															name="CouponCode"
															component="small"
															className="p-error"
														/>
													</div>
												</div>
											)}
											{ChannelPartners?.responseList && (
												<div className="form-group row">
													<label className="subcatchannelpartnersegory" htmlFor="channelpartners">Channel Partners<span className="astrik">*</span></label>
													<div className="input-errormsg">
														<select className="form-controls" id="channelpartners" value={selectedPartner} onChange={OnChangeChannelpartner}>
															<option value="">Select an App</option>
															{ChannelPartners?.responseList.map((ele, index) => (
																<option key={index} value={ele}>
																	{ele}
																</option>
															))}
														</select>
													</div>
												</div>
											)}
											{linkUrl !== '' && (
												<>
													<div className="form-group row">
														<div className="step-group" style={{ display: "flex" }}>
															<div className="step-header">Steps :</div>
															<div className="list-content">
																<div dangerouslySetInnerHTML={{ __html: linkUrl }} />
															</div>
														</div>
														{ButtonAction === Enums.Yes_NO && (
															<div className="not-satisfied" style={{ margin: "0 0 50px" }}>
																<hr style={{ border: "1px solid #ccc", margin: "20px 0" }} />
																<span className="conf-msg">Hope your issue is resolved</span>
																<button onClick={ConfirmYesButtonOnclick} className="conf-yes">
																	Yes
																</button>
																<button className="conf-no" onClick={ConfirmNOButtonOnclick}>NO</button>
															</div>
														)}
														{ButtonAction === Enums.Submit && (
															<div className="not-satisfied" style={{ margin: "0 0 50px" }}>
																<hr style={{ border: "1px solid #ccc", margin: "20px 0" }} />
																<span className="conf-msg">Hope your issue is resolved</span>
																<button className="conf-yes" onClick={ConfirmNOButtonOnclick}>Go To Home Page</button>
															</div>
														)}
													</div>
												</>
											)}
											{stepDIY?.diySteps && (
												<>
													<div className="form-group row">
														<div className="step-group" style={{ display: "flex" }}>
															<div className="step-header">Steps :</div>
															<div className="list-content">
																<div dangerouslySetInnerHTML={{ __html: stepDIY?.diySteps }} />
																{Array.isArray(stepDIY?.diyImage) && stepDIY.diyImage.length > 0 && (
																	<>
																		{stepDIY.diyImage.map((img, index) => (
																			<div className="qrc-img-url" key={index}>
																				<img src={stepDIY?.diyImage} alt={stepDIY?.category} width="100%" height="100%" />
																			</div>
																		))}
																	</>)}
															</div>
														</div>
													</div>
													{ButtonAction === Enums.Yes_NO && (
														<div className="not-satisfied" style={{ margin: "0 0 50px" }}>
															<hr style={{ border: "1px solid #ccc", margin: "20px 0" }} />
															<span className="conf-msg">Hope your issue is resolved</span>
															<button onClick={ConfirmYesButtonOnclick} className="conf-yes">
																Yes
															</button>
															<button className="conf-no" onClick={ConfirmNOButtonOnclick}>NO</button>
														</div>
													)}
													{ButtonAction === Enums.Submit && (
														<div className="not-satisfied" style={{ margin: "0 0 50px" }}>
															<hr style={{ border: "1px solid #ccc", margin: "20px 0" }} />
															<span className="conf-msg">Hope your issue is resolved</span>
															<button className="conf-yes" onClick={ConfirmNOButtonOnclick}>Go To Home Page</button>
														</div>
													)}
												</>
											)}
											{formFieldAction && (
												<>
													<div className="channel-partners-group"></div>
													<div className="step-group"></div>
													<div className="not-satisfied"></div>
													<div className="form-group row">
														<label className="description" htmlFor="description">Description<span className="astrik">*</span></label>
														<div className="input-errormsg" id="desc-countdown">
															<Field
																as="textarea"
																name="description"
																className="form-control"
																placeholder="Description"
															/>
															<ErrorMessage
																name="description"
																component="small"
																className="p-error"
															/>
														</div>
													</div>
													{/* <div className="form-group row image-upload"> */}
													<div className="form-group row">
														<label htmlFor="userImg">Add Attachment</label>
														<div className="input-errormsg">
															<label htmlFor="userImg" className="userImg">
																<img
																	className="defaultImg"
																	src={image || upload}
																	alt="preview"
																	onError={(e) => {
																		e.target.src = upload;
																	}}
																/>
															</label>
															<input
																type="file"
																// accept="image/*"
																accept=".jpg,.jpeg,.png,.jfif"
																hidden
																id="userImg"
																onChange={onUploadFile}
															/>
															<span style={{ color: '#b14d4d', fontSize: '12px', marginTop: '10px' }}>Allow file only (.jpg,.jpeg,.png,.jfif)</span>
														</div>
														<span className="uploadimg-error"></span>
													</div>
													<div className="form-group row">
														<ConfirmDialog  className="Contactpage" />
														<button type="submit" className="btn">Submit Ticket</button>
													</div>
												</>
											)}
										</Form>

									</div>
								</div>
								<div className={`tab-pane fade show ${tabTicketActive}`} id="list" role="tabpanel" aria-labelledby="list-tab">
									<div className="ticket-list">
										{WatchoComplaint && (
											WatchoComplaint.map((ele) => (
												<CompaintAccordionItem category={ele.category}
													subCategory={ele.subCategory} complainId={ele.complainID}
													status={ele.status}
													details={ele.complainDetails}
													time={new Date(ele.complainDate).toLocaleTimeString()}
													date={new Date(ele.complainDate).toLocaleDateString()} id={ele.categoryId} LinkUrl={ele.linkURL} />
											))
										)}
									</div>
								</div>
							</div>


							<Dialog 
								header={dialogData.header}
								visible={visible}
								onHide={() => setVisible(false)}
								footer={buttonColor == "success" ?
									<Button style={{ background: '#222',textDecoration: 'none', fontSize: '16px',border: '1px solid rgb(50 78 55)',padding: '4px 10px 4px 10px',
    borderRadius: '2px'}} label="OK" icon="pi pi-check" severity="success" onClick={() => DeActiveSteps(typebutton)} autoFocus /> : 
	<Button style={{ background: '#222',textDecoration: 'none', fontSize: '16px',border: '1px solid rgb(145 22 22)',padding: '4px 10px 4px 10px',
    borderRadius: '2px'}} label="OK" icon="pi pi-check" severity="danger" onClick={() => DeActiveSteps(typebutton)} autoFocus />}
								modal
								className={`contactpage p-dialog-${dialogData.severity} ` } style={{  maxWidth: '444px',textAlign: 'center'}}
							>
								<div className="flex align-items-center gap-2">
									<i className={`${dialogData.icon}`} style={{ color: 'green',fontSize: '2rem' }}></i>

									<div style={{ color: 'whitesmoke',wordWrap: 'break-word', whiteSpace: 'normal', overflowWrap: 'break-word',maxwidth: '444px',textalign: 'center',  }} dangerouslySetInnerHTML={{ __html: dialogData.message }} />
								</div>
							</Dialog>
							</div>
						</div>
				
				)}
				</Formik>
			</div>
		</div>

	);
}
